import Subject from './subject'

/**
 * Model
 * @extends {Subject}
 */
export default class Auth extends Subject {
  constructor() {
    super()
    this.state = {
      showAuthView: false,
      userBirthYear: '',
      userBirthMonth: '',
      userBirthDay: '',
      userAge: '',
      userCountry: '',
      userDrinkingAge: '',
      rememberAge: false,
      permission: false,
      showContents: false,
      submitDisable: true,
      annotationVisible: false
    }
  }

  action(type, val) {
    switch (type) {
      case 'showAuthView':
        this.state.showAuthView = true
        break

      case 'birthYearSelected':
        this.state.userBirthYear = val
        break

      case 'birthMonthSelected':
        this.state.userBirthMonth = val
        break

      case 'birthDaySelected':
        this.state.userBirthDay = val
        break

      case 'countrySelected':
        this.state.userCountry = val
        break

      case 'setUserAge':
        this.state.userAge = val
        break

      case 'setUserDrinkingAge':
        this.state.userDrinkingAge = val
        break

      case 'setPermission':
        this.state.permission = val
        break

      case 'rememberChecked':
        this.state.rememberAge = val
        break

      case 'submitAuth':
        if (this.state.permission){
          this.state.showContents = true
        }
        break

      case 'annotationVisible':
        this.state.annotationVisible = true
        break

      case 'clearUserData':
        const initialState = {
          rememberAge: false,
          userBirthYear: '',
          userBirthMonth: '',
          userBirthDay: '',
          userAge: '',
          userCountry: '',
          userDrinkingAge: '',
        }

        Object.assign(this.state, initialState)
        break
    }

    this.notify(type)
  }
}



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/auth/models/auth.js
 **/